import { HeroFeaturedBanner } from '@ahc-digital/component-library';
import { CreateHeroFeaturedBannerModel } from './B03HeroFeaturedBanner.service';
import { PromptForUnavailableInTheme } from 'src/shared/PromptForUnavailableInTheme';
import { useCustomSitecoreContext } from 'src/shared/useCustomSitecoreContext';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { B03HeroFeaturedBannerProps } from './B03HeroFeaturedBanner.types';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

const Default = (props?: B03HeroFeaturedBannerProps) => {
  const context = useCustomSitecoreContext();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (context?.siteTheme?.value === 'Consumer')
    return (
      <PromptForUnavailableInTheme
        siteTheme={context?.siteTheme?.value}
        componentName={props?.rendering?.componentName}
      />
    );
  return (
    <HeroFeaturedBanner
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...CreateHeroFeaturedBannerModel(props)}
    />
  );
};

export default checkDatasourceForRendering<B03HeroFeaturedBannerProps>(Default);
